import React, { useEffect, useState } from "react";
import css from "../css/gamehis.module.css";
import axios from "axios";
import Header from '../Components/Header';
import ReactPaginate from "react-paginate";
import Swal from 'sweetalert2';
import {
  FaUsers,
  FaWallet,
  FaShareAlt,
  FaCalendarAlt,
  FaGift,
  FaArrowLeft,
  FaCheckCircle,
  FaArrowRight
} from "react-icons/fa";
import { Link } from "react-router-dom";

const Referralhis = () => {
  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
  const nodeMode = process.env.NODE_ENV;

  let baseUrl;
  if (nodeMode === "development") {
    baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
  }

  const [user, setUser] = useState(null);
  const [cardData, setGame] = useState([]);
  const [totalReferralCount, setTotalReferralCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [WebSitesettings, setWebsiteSettings] = useState(null);

  // Pagination States
  const [pageNumber, setPageNumber] = useState(1);
  const [numberOfPages, setNumberOfPages] = useState(0);
  const limit = 10;

  // Fetch logged in user profile
  const role = async () => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`
    };

    try {
      const res = await axios.get(baseUrl + `me`, { headers });
      setUser(res.data);
      if (res.data && res.data._id) {
        Allgames(res.data._id, pageNumber);
      } else {
        setLoading(false);
      }
    } catch (err) {
      console.error("Error fetching user profile:", err);
      setLoading(false);
    }
  };

  // Fetch referral list history
  const Allgames = async (id, pageNum) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`
    };

    try {
      const res = await axios.get(baseUrl + `referral/history/${id}?page=${pageNum}&limit=${limit}`, { headers });
      const data = res.data;
      if (data && Array.isArray(data.data)) {
        setGame(data.data);
        setNumberOfPages(data.totalPages || 0);
        setTotalReferralCount(data.referuserCount || 0);
      } else if (Array.isArray(data)) {
        setGame(data);
        setNumberOfPages(Math.ceil(data.length / limit));
      } else if (data && Array.isArray(data.history)) {
        setGame(data.history);
        setNumberOfPages(data.totalPages || 0);
      } else if (data && Array.isArray(data.list)) {
        setGame(data.list);
        setNumberOfPages(data.totalPages || 0);
      } else if (data && typeof data === "object") {
        // If it's a single object, wrap it in an array
        setGame([data]);
        setNumberOfPages(1);
      } else {
        setGame([]);
        setNumberOfPages(0);
      }
    } catch (err) {
      console.error("Error calling referral/history API:", err);
      // Fallback to other possible endings in case of backend spelling variations
      try {
        const fallbackRes = await axios.get(baseUrl + `referral/code/winn/${user?.referral_code || id}?page=${pageNum}&limit=${limit}`, { headers });
        const fallbackData = fallbackRes.data;
        if (Array.isArray(fallbackData)) {
          setGame(fallbackData);
          setNumberOfPages(Math.ceil(fallbackData.length / limit));
        } else if (fallbackData && Array.isArray(fallbackData.data)) {
          setGame(fallbackData.data);
          setNumberOfPages(fallbackData.totalPages || 0);
        } else {
          setGame([]);
          setNumberOfPages(0);
        }
      } catch (fallbackErr) {
        console.error("Fallback API failed:", fallbackErr);
        setGame([]);
        setNumberOfPages(0);
      }
    } finally {
      setLoading(false);
    }
  };

  // Fetch website settings
  const fetchSettings = async () => {
    try {
      const response = await fetch(baseUrl + "settings/data");
      const data = await response.json();
      setWebsiteSettings(data);
    } catch (err) {
      console.error("Error fetching settings:", err);
    }
  };

  useEffect(() => {
    role();
    fetchSettings();
    // eslint-disable-next-line
  }, [pageNumber]);

  const handlePageClick = async (data) => {
    let currentPage = data.selected + 1;
    setPageNumber(currentPage);
  };

  const dateFormat = (e) => {
    if (!e) return "N/A";
    const date = new Date(e);
    return date.toLocaleString('default', {
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    });
  };

  // Copy referral code
  const copyCode = () => {
    if (!user || !user.referral_code) return;
    navigator.clipboard.writeText(user.referral_code);
    Swal.fire({
      position: 'center',
      icon: 'success',
      title: 'Referral Code Copied!',
      showConfirmButton: false,
      timer: 1200,
      background: '#0e1d30',
      color: '#fff',
      customClass: {
        popup: 'border-gradient'
      }
    });
  };



  return (
    <div style={{ backgroundColor: "#0b1426", minHeight: "100vh", color: "#fff" }}>
      {/* Embedded CSS for premium UI styling and transitions */}
      <style>{`
        .border-gradient {
          border: 2px solid transparent;
          border-image: linear-gradient(to right, #ff416c, #ff4b2b) 1;
        }
        .ref-card-bg {
          background: linear-gradient(135deg, rgba(20, 35, 60, 0.9) 0%, rgba(13, 23, 42, 0.95) 100%);
          border: 1px solid rgba(255, 255, 255, 0.08);
          border-radius: 16px;
          transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
        }
        .ref-card-bg:hover {
          transform: translateY(-4px);
          border-color: rgba(60, 214, 60, 0.4);
          box-shadow: 0 12px 30px rgba(0, 0, 0, 0.4);
        }
        .gradient-header {
          background: linear-gradient(135deg, #1e3c72 0%, #1a2a6c 50%, #240b36 100%);
          border-bottom: 2px solid rgba(255, 255, 255, 0.1);
        }
        .stat-card {
          background: rgba(255, 255, 255, 0.04);
          border: 1px solid rgba(255, 255, 255, 0.06);
          border-radius: 12px;
          padding: 12px 16px;
          flex: 1;
          display: flex;
          align-items: center;
          gap: 12px;
        }
        .search-container {
          background: rgba(255, 255, 255, 0.05);
          border: 1px solid rgba(255, 255, 255, 0.1);
          border-radius: 12px;
          display: flex;
          align-items: center;
          padding: 0 16px;
          margin: 16px;
        }
        .search-input {
          background: transparent;
          border: none;
          color: #fff;
          padding: 12px 8px;
          width: 100%;
          font-size: 0.95rem;
        }
        .search-input:focus {
          outline: none;
        }
        .avatar-circle {
          width: 45px;
          height: 45px;
          border-radius: 50%;
          background: linear-gradient(45deg, #ff416c, #ff4b2b);
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
          font-size: 1.2rem;
          box-shadow: 0 4px 10px rgba(255, 65, 108, 0.3);
        }
        .badge-active {
          background: rgba(60, 214, 60, 0.15);
          color: #3cd63c;
          font-size: 0.75rem;
          padding: 4px 10px;
          border-radius: 20px;
          border: 1px solid rgba(60, 214, 60, 0.3);
          font-weight: 500;
        }
        .animate-fade-in {
          animation: fadeIn 0.6s ease-out;
        }
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .share-banner {
          background: linear-gradient(135deg, rgba(60, 214, 60, 0.15) 0%, rgba(20, 35, 60, 0.5) 100%);
          border: 1px dashed rgba(60, 214, 60, 0.4);
          border-radius: 16px;
          padding: 24px;
          text-align: center;
          margin: 20px 16px;
        }
        .share-btn {
          background: #25d366;
          color: #fff;
          border: none;
          border-radius: 10px;
          padding: 12px 24px;
          font-weight: 600;
          display: inline-flex;
          align-items: center;
          gap: 8px;
          transition: all 0.2s;
          text-decoration: none;
          margin-top: 12px;
          box-shadow: 0 4px 15px rgba(37, 211, 102, 0.3);
        }
        .share-btn:hover {
          transform: scale(1.03);
          box-shadow: 0 6px 20px rgba(37, 211, 102, 0.4);
          color: #fff;
        }
        /* Premium custom style for ReactPaginate */
        .pagination {
          display: flex;
          padding-left: 0;
          list-style: none;
          border-radius: 0.25rem;
          justify-content: center;
          align-items: center;
          gap: 6px;
        }
        .page-item .page-link {
          background: rgba(255, 255, 255, 0.05) !important;
          border: 1px solid rgba(255, 255, 255, 0.1) !important;
          color: #fff !important;
          padding: 8px 16px;
          border-radius: 8px !important;
          transition: all 0.2s;
        }
        .page-item:hover .page-link {
          background: rgba(60, 214, 60, 0.2) !important;
          border-color: rgba(60, 214, 60, 0.4) !important;
          color: #3cd63c !important;
        }
        .page-item.active .page-link {
          background: #3cd63c !important;
          border-color: #3cd63c !important;
          color: #0b1426 !important;
          font-weight: bold;
        }
        .page-item.disabled .page-link {
          opacity: 0.4;
          cursor: not-allowed;
          background: rgba(255, 255, 255, 0.02) !important;
        }
      `}</style>

      <Header user={user} />

      <div className="leftContainer" style={{ minHeight: '100vh', height: '100%', paddingBottom: "80px" }}>

        {/* Premium Dashboard Summary Panel */}
        <div className="gradient-header p-4 text-white">
          <div className="d-flex align-items-center mb-3">
            <Link to="/refer" className="text-white mr-3">
              <FaArrowLeft size={18} />
            </Link>
            <h4 className="m-0 font-weight-bold" style={{ letterSpacing: "0.5px" }}>Referral History</h4>
          </div>

          <p className="text-white-50 small mb-4">
            Track all your invited friends, active commissions, and instant earnings in real-time.
          </p>

          <div className="d-flex flex-wrap gap-3" style={{ gap: "12px" }}>
            <div className="stat-card">
              <div style={{ background: "rgba(60, 214, 60, 0.15)", borderRadius: "10px", padding: "10px", color: "#3cd63c" }}>
                <FaUsers size={20} />
              </div>
              <div>
                <div className="text-white-50" style={{ fontSize: "0.75rem" }}>Total Referred</div>
                <h5 className="m-0 font-weight-bold">{totalReferralCount} Friends</h5>
              </div>
            </div>

            <div className="stat-card">
              <div style={{ background: "rgba(255, 193, 7, 0.15)", borderRadius: "10px", padding: "10px", color: "#ffc107" }}>
                <FaWallet size={20} />
              </div>
              <div>
                <div className="text-white-50" style={{ fontSize: "0.75rem" }}>Total Earned</div>
                <h5 className="m-0 font-weight-bold">₹{user?.referral_earning || 0}</h5>
              </div>
            </div>
          </div>

          {user?.referral_code && (
            <div className="mt-4 p-3 d-flex align-items-center justify-content-between" style={{ background: "rgba(255,255,255,0.06)", borderRadius: "12px" }}>
              <div className="small text-white-50">
                Your Code: <strong className="text-white ml-1" style={{ fontSize: "1.05rem" }}>{user.referral_code}</strong>
              </div>
              <button
                onClick={copyCode}
                className="btn btn-sm btn-outline-light px-3 py-1 font-weight-bold"
                style={{ borderRadius: "8px", fontSize: "0.8rem", border: "1px solid rgba(255,255,255,0.2)", backgroundColor: "#00ffff" }}
              >
                Copy Code
              </button>
            </div>
          )}
        </div>

        {/* Loading Indicator */}
        {loading ? (
          <div className="d-flex flex-column align-items-center justify-content-center pt-5" style={{ minHeight: "30vh" }}>
            <div className="spinner-border text-success" role="status">
              <span className="sr-only">Loading...</span>
            </div>
            <div className="mt-3 text-white-50 small">Loading your referrals...</div>
          </div>
        ) : (
          <div className="animate-fade-in mt-3">
            {/* List of Referred Users */}
            <div className="px-3">
              {Array.isArray(cardData) && cardData.map((card, index) => {
                // Determine display name defensively
                const rawName = card.Name || card.name || card.username || card.Username || "";
                const rawPhone = card.Phone || card.phone || "";

                let displayName = "Referred Friend";
                if (rawName) {
                  displayName = rawName;
                } else if (rawPhone) {
                  // Mask middle characters of phone number for privacy
                  displayName = rawPhone.length >= 10
                    ? `${rawPhone.substring(0, 2)}******${rawPhone.substring(8)}`
                    : rawPhone;
                }

                const initialLetter = displayName.charAt(0).toUpperCase() || "R";
                const cardDateStr = card.created_at || card.createdAt || card.date || "";
                const amountEarned = card.amount || card.referral_earning || card.commission || 0;

                return (
                  <div className="ref-card-bg p-3 mb-3 d-flex align-items-center justify-content-between" key={card._id || index}>
                    <div className="d-flex align-items-center gap-3" style={{ gap: "14px" }}>
                      <div className="avatar-circle">
                        {initialLetter}
                      </div>
                      <div>
                        <div className="font-weight-bold text-white mb-1" style={{ fontSize: "0.95rem" }}>
                          {displayName}
                        </div>
                        <div className="text-white-50 small d-flex align-items-center gap-1" style={{ gap: "6px", fontSize: "0.75rem" }}>
                          <FaCalendarAlt size={10} className="text-success" />
                          <span>Joined {dateFormat(cardDateStr)}</span>
                        </div>
                      </div>
                    </div>

                    <div className="text-right">
                      {amountEarned > 0 ? (
                        <div className="text-success font-weight-bold" style={{ fontSize: "1.05rem" }}>
                          +₹{amountEarned}
                        </div>
                      ) : (
                        <span className="badge-active">
                          <FaCheckCircle size={10} className="mr-1" /> Registered
                        </span>
                      )}

                      {card.closing_balance !== undefined && (
                        <div className="text-white-50 small mt-1" style={{ fontSize: "0.65rem" }}>
                          Closing: ₹{card.closing_balance}
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Pagination Component */}
            {(numberOfPages > 1 || (Array.isArray(cardData) && cardData.length === limit) || pageNumber > 1) && (
              <div className="py-4">
                <ReactPaginate
                  previousLabel={"Previous"}
                  nextLabel={"Next"}
                  breakLabel={"..."}
                  pageCount={numberOfPages > 1 ? numberOfPages : ((Array.isArray(cardData) && cardData.length === limit) ? pageNumber + 1 : pageNumber)}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  onPageChange={handlePageClick}
                  containerClassName={"pagination justify-content-center"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                  previousClassName={"page-item"}
                  previousLinkClassName={"page-link"}
                  nextClassName={"page-item"}
                  nextLinkClassName={"page-link"}
                  breakClassName={"page-item"}
                  breakLinkClassName={"page-link"}
                  activeClassName={"active"}
                  forcePage={pageNumber - 1}
                />
              </div>
            )}

            {/* Empty State Redirection */}
            {(Array.isArray(cardData) ? cardData.length : 0) === 0 && (
              <div className="text-center px-4 py-5 animate-fade-in">
                <img
                  src={process.env.PUBLIC_URL + '/Images/notransactionhistory.png'}
                  alt="no referrals"
                  width={200}
                  height={200}
                  className="img-fluid mb-4"
                  style={{ opacity: 0.8 }}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/Images/LandingPage_img/sreferEarn.png";
                  }}
                />

                <h4 className="font-weight-bold mt-2">No Referrals Yet</h4>
                <p className="text-white-50 mx-auto small mb-4" style={{ maxWidth: "340px" }}>
                  Earn unlimited commissions by sharing your referral code with your friends and family! Get 3% commission on their winnings.
                </p>

                <div className="share-banner">
                  <h6 className="font-weight-bold text-success mb-2">🎁 Share &amp; Start Earning</h6>
                  <p className="small text-white-50 mb-3">Copy your code or share directly via WhatsApp to invite friends.</p>

                  <div className="d-flex align-items-center justify-content-center gap-2 mb-3" style={{ gap: "8px" }}>
                    <span className="px-3 py-2 bg-dark rounded border-secondary border text-white font-weight-bold" style={{ letterSpacing: "1px" }}>
                      {user?.referral_code || "CODE"}
                    </span>
                    <button onClick={copyCode} className="btn btn-success py-2 px-3 font-weight-bold" style={{ borderRadius: "8px" }}>
                      Copy
                    </button>
                  </div>

                  <a
                    href={`whatsapp://send?text=Play Ludo and earn ₹10000 daily. Register now using my referral link: ${(WebSitesettings) ? WebSitesettings.CompanyWebsite : ''}/login/${user?.referral_code || ''} and use code: ${user?.referral_code || ''}`}
                    className="share-btn"
                  >
                    <FaShareAlt /> Invite Friends
                  </a>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Referralhis;
